import { fetch_proto_history } from '@ducat-unit/client-sdk/lib';
import type { ProtoProfile, VaultProfile } from '@ducat-unit/core';
import { verify_proto_profile } from '@ducat-unit/core/lib';
import { proto as proto_schema } from '@ducat-unit/core/schema';

import type { NetworkSettingsConfig } from '@/config/config.types';

// Match Guardian verification: history comes from the configured validator;
// Core checks the profile schema and contract placement, then we bind its identity
// to this vault and deployment. This is not an independent chain-history proof.
export async function resolve_vault_protocol(
  proto_profile: ProtoProfile,
  vault_profile: VaultProfile,
  config: NetworkSettingsConfig,
): Promise<ProtoProfile> {
  if (vault_profile.contract_id === proto_profile.contract_id) return proto_profile;

  const history = await fetch_proto_history(config.validatorUrl);
  if (!history.ok) throw new Error(`Failed to fetch predecessor protocol: ${history.error}`);
  const record = history.data.find((entry) => entry.contract_id === vault_profile.contract_id);
  if (!record) throw new Error(`Previous vault contract is missing: ${vault_profile.contract_id}`);

  const previous_proto = proto_schema.profile.parse(record);
  verify_proto_profile(previous_proto);
  if (previous_proto.anchor_id !== proto_profile.anchor_id) {
    throw new Error('Predecessor protocol anchor mismatch');
  }
  if (previous_proto.chain_network !== proto_profile.chain_network) {
    throw new Error('Predecessor protocol network mismatch');
  }
  return previous_proto;
}
